import React from "react";
import { Clock, CheckCircle2, XOctagon } from "lucide-react";
import { t } from "@/lib/i18n";

const fmtUSD = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export default function HoldStatusCards({ lang, data }) {
  if (!data) return null;
  const holdDays = data.commission_hold_days || 30;
  const cards = [
    {
      key: "pending",
      icon: Clock,
      label: t(lang, "hold_pending"),
      sub: `${holdDays}-${t(lang, "hold_day_window")}`,
      value: fmtUSD(data.earnings_pending_usd),
      testid: "hold-pending-card",
      cls: "border-[#fde047]/40 bg-[#fde047]/[0.06] text-[#fde047]",
    },
    {
      key: "released",
      icon: CheckCircle2,
      label: t(lang, "hold_released"),
      sub: t(lang, "hold_released_sub"),
      value: fmtUSD(data.earnings_released_usd),
      testid: "hold-released-card",
      cls: "border-[#86efac]/40 bg-[#86efac]/[0.06] text-[#86efac]",
      highlight: true,
    },
    {
      key: "cancelled",
      icon: XOctagon,
      label: t(lang, "hold_cancelled"),
      sub: `${data.total_cancelled || 0} ${t(lang, "hold_cancelled_sub")}`,
      value: fmtUSD(data.earnings_cancelled_usd),
      testid: "hold-cancelled-card",
      cls: "border-[#fca5a5]/40 bg-[#fca5a5]/[0.06] text-[#fca5a5]",
    },
  ];

  return (
    <section
      className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6 anim-fade-up anim-delay-2"
      data-testid="hold-status-cards"
    >
      {cards.map((c) => (
        <div key={c.key} className={`eigoo-card p-6 border ${c.cls.split(" ").slice(0, 1).join(" ")}`} data-testid={c.testid}>
          <div className="flex items-start justify-between">
            <div className="min-w-0">
              <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400">
                {c.label}
              </div>
              <div
                className={`font-display mt-3 text-3xl font-extrabold tabular-nums ${
                  c.highlight ? "gold-gradient-text" : "text-white"
                }`}
              >
                {c.value}
              </div>
              <div className="text-xs text-slate-400 mt-2">{c.sub}</div>
            </div>
            <div className={`w-11 h-11 rounded-xl grid place-items-center border ${c.cls}`}>
              <c.icon className="w-5 h-5" />
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
